import React from "react"
//import { LanguageContext } from "../../context"
import Icon from "../icon"

 const SocialMediaItem = (props) => {

   const {
     title,
     icon,
     url,
     className,
     size,
     iconClassName
   } = props

   //const { t } = useContext(LanguageContext)
   return (
      <li className={className} key={icon}>
        <a href={url} alt={title} target="_blank" rel="noreferrer">
          <Icon
            icon={icon}
            size={size}
            className={iconClassName}
            color="#ffffff"
          />
        </a>
      </li>
   )
 }

 export default SocialMediaItem
